import { parseDicom, explicitDataSetToJS } from "dicom-parser";
import { convertCompilerOptionsFromJson } from "typescript";
import { xml2json } from "xml-js";

const checkIfDICOM = (array: Uint8Array) => {
  let s = "";
  const start = 128,
    end = 132;
  for (let i = start; i < end; ++i) {
    s += String.fromCharCode(array[i]);
  }

  if (s == "DICM") {
    return true;
  } else {
    return false;
  }
};

const convertBase64ToArray = (base64: string) => {
  const rawString = atob(base64);
  const int8Array = new Int8Array(rawString.length);
  for (let i = 0; i < rawString.length; i++) {
    int8Array[i] = rawString.charCodeAt(i);
  }
  const int16Array = new Int16Array(int8Array.buffer);
  return Array.from(int16Array);
};

const processMUSEDICOM = (array: Uint8Array, setUploadMessage: (message: string) => void): Array<any> => {
  try {
    const dataSet = parseDicom(array);

    const options = {
      omitPrivateAttibutes: false,
      maxElementLength: 128,
    };

    const instance = explicitDataSetToJS(dataSet, options) as any;

    for (const element of instance["x54000100"]) {
      if (element["x003a0020"] == "MEDIAN BEAT") {
        console.log("Found median beat!");
        const dataOffset: any = element["x54001010"]["dataOffset"];
        const dataLength: any = element["x54001010"]["length"];
        const noOfLeads: number = element["x003a0005"];
        const sampleLength: number = parseInt(element["x003a0010"]);
        const sampleRate: number = parseInt(element["x003a001a"]);
        const ecgData = new Int16Array(array.slice(dataOffset, dataOffset + dataLength).buffer);

        const ecgDataPerLead: Array<any> = [];
        const leadNames = ["I", "II", "III", "aVR", "aVL", "aVF", "V1", "V2", "V3", "V4", "V5", "V6"];
        for (let i = 0; i < noOfLeads; i++) {
          ecgDataPerLead.push({
            lead: leadNames[i],
            data: Array.from(
              ecgData.filter((element, index) => {
                return index % 12 === i;
              })
            ),
            length: sampleLength,
            sample_rate: sampleRate,
            baseline: parseInt(element["x003a0200"][i]["x003a0213"]),
            gain: parseFloat(element["x003a0200"][i]["x003a0210"]) * parseFloat(element["x003a0200"][i]["x003a0212"]),
            unit: element["x003a0200"][i]["x003a0211"][0]["x00080104"].toLowerCase(),
          });
        }
        return ecgDataPerLead;
      }
    }
    setUploadMessage("Error reading ECG file, Please provide a valid GE MUSE DCM file containing a median beat");
    return [];
  } catch (error) {
    console.log(error);
    setUploadMessage("Error reading ECG file, Please provide a valid GE MUSE DCM file containing a median beat");
    return [];
  }
};

const processMUSEXML = (ECGFileReader: FileReader, setUploadMessage: (message: string) => void): Array<any> => {
  try {
    const content = new TextDecoder().decode(ECGFileReader.result as ArrayBuffer);
    const result1 = JSON.parse(xml2json(content, { compact: true, spaces: 4 }));
    if ("RestingECG" in result1) {
      for (const element of result1.RestingECG.Waveform) {
        if (element.WaveformType._text == "Median") {
          console.log("Found median beat!");
          const ecgDataPerLead: Array<any> = [];
          element.LeadData.forEach((lead: any) => {
            ecgDataPerLead.push({
              lead: lead.LeadID._text,
              data: convertBase64ToArray(lead.WaveFormData._text),
              length: parseInt(lead.LeadSampleCountTotal._text),
              sample_rate: parseInt(element.SampleBase._text),
              baseline: parseInt(lead.LeadOffsetFirstSample._text),
              gain: parseFloat(lead.LeadAmplitudeUnitsPerBit._text),
              unit: lead.LeadAmplitudeUnits._text.toLowerCase(),
            });
          });
          return ecgDataPerLead;
        }
      }
    }
    setUploadMessage("Error reading ECG file, please provide a valid GE MUSE XML file containing a median beat");
    return [];
  } catch (error) {
    console.log(error);
    setUploadMessage("Error reading ECG file, please provide a valid GE MUSE XML file containing a median beat");
    return [];
  }
};

export default function ProcessUpload(ECGFileReader: FileReader, setUploadMessage: (message: string) => void): Array<any> {
  const array = new Uint8Array(ECGFileReader.result as ArrayBuffer);
  if (checkIfDICOM(array)) {
    console.log("Processing as DCM");
    setUploadMessage("Error reading ECG file, please provide a valid GE MUSE XML file containing a median beat");
    return [];
    //return processMUSEDICOM(array, setUploadMessage);
  } else {
    console.log("Processing as XML");
    return processMUSEXML(ECGFileReader, setUploadMessage);
  }
}

// OLD DICOM
// const keys = [];
// for (const propertyName in dataSet.elements) {
//   keys.push(propertyName);
// }
// keys.sort();
// console.log(keys);

// for (let k = 0; k < keys.length; k++) {
//   const propertyName = keys[k];
//   const element = dataSet.elements[propertyName];
//   const str = dataSet.string(propertyName);
//   console.log(str);
// }
// const waveform_data = dataSet.elements["x54000100"].items;
// console.log(waveform_data);
// const dataOffset: any = waveform_data?.[1].dataSet?.elements["x54001010"]["dataOffset"];
// const dataLength: any = waveform_data?.[1].dataSet?.elements["x54001010"]["length"];
// const ecgData = new Int16Array(array.slice(dataOffset, dataOffset + dataLength).buffer);
// console.log(ecgData);
// const lead1 = ecgData.filter((element, index) => {
//   return index % 12 === 3;
// });
// const convertedECG = [
//   {
//     id: `Uploaded ECG`,
//     data: (Array.from(lead1) as any).map((y: number, x: number) => ({
//       x: x,
//       y: y,
//     })),
//   },
// ];
// setECG(convertedECG);
// console.log(lead1);

// const convertedECG = [
//   {
//     id: `Uploaded ECG`,
//     data: (Array.from(int16Array) as any).map((y: number, x: number) => ({
//       x: x,
//       y: y * 0.00488,
//     })),
//   },
// ];
// setECG(convertedECG);
// setUploadMessage("Successfully read ECG file");
